module.exports = __webpack_public_path__ + "img/020.aadd1eff.png";